import { computeDistanceBetween } from "app/helpers/geoHelper";
import CardItem from "app/components/UI/CardItem";
import Flex from "app/components/UI/Flex";
import ImmutablePropTypes from "react-immutable-proptypes";
import PropTypes from "prop-types";
import React from "react";
import classes from "./ClubListItem.module.css";

export const ClubListItem = ({ club, onChangeClub, currentPosition }) => {
  const near = currentPosition
    ? `${computeDistanceBetween(currentPosition.lat, currentPosition.lon, club.get("x"), club.get("y"))} km`
    : "";
  return (
    <Flex className={classes.clubItem} key={club.get("@id")} onClick={() => onChangeClub(club.get("@id"))}>
      <CardItem
        title={club.getIn(["publicMetadata", "title"])}
        subtitle={<span>{club.getIn(["publicMetadata", "description"])}</span>}
        right={near}
      />
    </Flex>
  );
};

ClubListItem.propTypes = {
  club: ImmutablePropTypes.map.isRequired,
  onChangeClub: PropTypes.func.isRequired,
  currentPosition: PropTypes.object
};

export default ClubListItem;



// WEBPACK FOOTER //
// ./src/app/components/ClubListItem/ClubListItem.js